<template>
	<header class="wrapper">
		<div>		
			<logo></logo>

			<menu-comp></menu-comp>
		</div>
	</header>
</template>

<script>
	import Logo from './Logo'
	import MenuComp from './Menu'

	export default {
		name: 'header-comp',
		components: {
			Logo,
			MenuComp
		}
	}
</script>

<style lang="scss">
	header {
		position: relative;
		z-index: 50;
		padding: 5vh 0;

		&.wrapper {
			max-width: 650px;
		}

		> div {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
	}
</style>


// WEBPACK FOOTER //
// src/vue/components/common/header/Header.vue?6549cf7d